<template>
  <g>
    <path
      d="M511.9,511.8h6.2v-15c0-5.3-1.7-9.3-7.5-9.3c-2.9,0-6.1,1.3-7.5,4.2c-1.3-3-3.7-4.2-7-4.2   c-2.3,0-5.1,1-7.1,3.9h-0.1V488H483v23.8h6.2v-11.6c0-3.1,0.5-8,4.6-8c3.6,0,3.6,3.1,3.6,5.4v14.2h6.2v-11.6c0-3.1,0.5-8,4.6-8   c3.6,0,3.6,3.1,3.6,5.4v14.2H511.9z M532.6,500c0,18.1-14.6,32.6-32.6,32.6c-17.9,0-32.6-14.6-32.6-32.6s14.6-32.6,32.6-32.6   S532.6,482.1,532.6,500 M539.6,500c0-21.8-17.7-39.6-39.6-39.6c-21.8,0-39.6,17.7-39.6,39.6c0,21.8,17.7,39.6,39.6,39.6   C521.8,539.6,539.6,521.8,539.6,500"
      style="fill: #f02d1e"
    />

    <path
      v-if="validity !== null && ! validity"
      d="m 556.53677,414.39177 c 12.30731,-10.54502 32.3149,-10.59149 44.69151,-0.1019 12.36771,10.48656 12.42101,27.53789 0.12081,38.07393 l -53.99972,46.21432 54.05657,46.25629 c 12.19894,10.46108 12.0337,27.40447 -0.36955,37.84906 -12.40681,10.44009 -32.354,10.4131 -44.54937,-0.0465 L 502.8,536.7 449.01171,582.72243 c -12.30731,10.54503 -32.31491,10.5915 -44.69151,0.1019 -12.36772,-10.48655 -12.42279,-27.53789 -0.12081,-38.07393 l 53.99972,-46.21432 -54.0548,-46.25779 c -12.20072,-10.46108 -12.0337,-27.40447 0.36956,-37.84906 12.4068,-10.43859 32.35399,-10.41309 44.54936,0.0465 l 53.68702,45.93847 z"
      stroke="#F02D1E"
      fill="#F02D1E"
      stroke-width="25"
    />

    <path
      v-if="validity !== null && validity"
      d="m 372.66788,484.36575 c -7.45592,-6.36014 -11.30992,-14.82109 -11.50483,-23.33976 -0.19232,-8.51636 3.27707,-17.1112 10.43414,-23.73453 7.15185,-6.6187 16.67641,-10.04463 26.26334,-10.21548 9.59213,-0.17545 19.26221,2.89728 26.72333,9.26204 L 489,491.4 617.24757,346.67963 l 4.59466,3.11428 -4.59986,-3.12813 c 0.36643,-0.42247 0.78224,-0.7826 1.24483,-1.0758 7.63003,-5.87073 17.20657,-8.52098 26.5674,-8.06849 v -0.009 l 0.45739,0.0369 c 9.41539,0.55407 18.61252,4.27088 25.40315,11.00271 6.90757,6.84494 10.03911,15.53907 9.51676,24.03695 h 0.0101 l -0.0415,0.40631 c -0.61335,8.21394 -4.65447,16.24087 -11.97784,22.23626 l -153.9106,166.42566 0.0101,0.009 c -0.28845,0.32551 -0.61331,0.60485 -0.96674,0.84956 -7.20644,5.62139 -16.30739,8.37784 -25.35638,8.23933 -9.12434,-0.14083 -18.23049,-3.22279 -25.31478,-9.27127 z"
      stroke="#64b911"
      fill="#64b911"
      stroke-width="1"
      ></path>
  </g>
</template>

<script>
export default {
  props: {
    validity: {
      type: Boolean,
      required: false,
      default: null,
    },
  },
};
</script>